import './styles.css';
import { createRouter } from './lib/router.js';
import { appShell } from './components/layout.js';
import { HomePage } from './pages/home.js';
import { FeasoPage } from './pages/feaso.js';
import { ScenariosPage } from './pages/scenarios.js';
import { FinderPage } from './pages/finder.js';
import { FinderNewPage } from './pages/finder-new.js';
import { FinderDetailPage } from './pages/finder-detail.js';
import { LibraryPage } from './pages/library.js';

const mount = document.getElementById('app');

const routes = [
  { path: /^\/$/, render: (ctx) => appShell(HomePage(ctx)) },
  { path: /^\/feaso(?:\/(?<id>[^/]+))?$/, render: (ctx) => appShell(FeasoPage(ctx)) },
  { path: /^\/scenarios$/, render: (ctx) => appShell(ScenariosPage(ctx)) },
  { path: /^\/finder\/new$/, render: (ctx) => appShell(FinderNewPage(ctx)) },
  { path: /^\/finder\/(?<id>[^/]+)$/, render: (ctx) => appShell(FinderDetailPage(ctx)) },
  { path: /^\/finder$/, render: (ctx) => appShell(FinderPage(ctx)) },
  { path: /^\/library$/, render: (ctx) => appShell(LibraryPage(ctx)) },
];

createRouter(routes, mount);
